import { addDoc, arrayUnion, collection, doc, onSnapshot, query, updateDoc, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { docsWithId, logListenerError, withId } from './db';

const conversationsCollection = () => collection(db, 'conversations');
const conversationRef = (id) => doc(db, 'conversations', id);

/** Live conversations a profile takes part in. */
export function subscribeConversations(profileId, onChange, onError = logListenerError('conversations')) {
  const q = query(conversationsCollection(), where('participants', 'array-contains', profileId));
  return onSnapshot(q, (snapshot) => onChange(docsWithId(snapshot)), onError);
}

/** Live single conversation ({ id, ...data } or null). */
export function subscribeConversation(id, onChange, onError = logListenerError('conversation')) {
  return onSnapshot(conversationRef(id), (snap) => onChange(withId(snap)), onError);
}

/** A message object as stored in a conversation's messages array. */
export function buildMessage(senderId, text) {
  return { senderId, text, timestamp: Date.now() };
}

/** Start a conversation, optionally with a first message. Resolves { id, ...conversation }. */
export async function startConversation({ participants, isGroup = false, groupName = null, message = null }) {
  const conversation = { participants, isGroup, groupName, messages: message ? [message] : [], createdAt: Date.now() };
  const ref = await addDoc(conversationsCollection(), conversation);
  return { id: ref.id, ...conversation };
}

/** Append a message (security rules require senderId to be the signed-in user). */
export function sendMessage(conversationId, message) {
  return updateDoc(conversationRef(conversationId), { messages: arrayUnion(message) });
}
